import {CLStore} from 'common/src/redux/store';
import {AgentName} from '../copilot.enums';
import {Agent} from '../copilot.types';
import supportSkill from '../skills/definitions/supportSkill/supportSkill';
import skills__agent from '../utils/creators/skills__agent';

export default function supportSkillsAgent(store: CLStore): Agent {
  return skills__agent({
    store,
    getSkills: () => [supportSkill()],
    name: AgentName.Support,
    role: 'You are the agent responsible for first-line user support.',
  });
}
